import React from "react";

import { StyledSVG } from "../StyledIcon";

export const HappyIcon = props => {
  const { iconColor, iconWidth, iconHeight } = props;

  return (
    <StyledSVG
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <circle
        cx="9"
        cy="9"
        r="7.25"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="7" r="1" fill={iconColor} />
      <circle cx="12" cy="7" r="1" fill={iconColor} />
      <path
        d="M13.1052 10.1C12.863 11.0037 12.3295 11.8022 11.5872 12.3718C10.845 12.9413 9.93557 13.25 9 13.25C8.06443 13.25 7.155 12.9413 6.41276 12.3718C5.67052 11.8022 5.13696 11.0037 4.89481 10.1"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledSVG>
  );
};
